import { useQuery } from "@tanstack/react-query";
import { leaseService } from "../../../../configs/constants";
import axios from "../../../../utils/axiosInceptor";
import { transformApiToGroups } from "../../../molecules/PendingApprovals/utili";
import { PENDING_REQUESTS_KEY } from "./constants";

const fetchPendingRequests = async () => {
  const pendingRequestsUrl = leaseService + "/booking/getApprovals/pending";
  const { data } = await axios.get(pendingRequestsUrl);
  return transformApiToGroups(data?.result ?? {});
};

export const usePendingRequests = (isPendingApprovalEnabled: boolean = true) =>
  useQuery({
    queryKey: PENDING_REQUESTS_KEY,
    enabled: isPendingApprovalEnabled,
    queryFn: fetchPendingRequests,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });
